module.exports = __webpack_public_path__ + "img/IMG_1024_L_Wood_MockedUp.8667ce03.jpg";